import type { FeapiError } from "@edreamsodigeo/frontend-api-client";

import useIsLoggedInUser from "~/clientState/hooks/useIsLoggedInUser";
import { useIsPrimeMarket } from "~/clientState/hooks/usePrimeSitePropertiesQuery";
import useUserAccount from "~/clientState/hooks/useUserAccount";
import { isMembershipActivatedWithUserAccountData } from "~/clientState/hooks/utils/MembershipUtils";
import type { GetUserAccountQuery } from "~/generated/graphql";

interface LoyaltyProgramReturn {
  userAccountData: GetUserAccountQuery | null;
  isEligibleForLoyaltyProgram: boolean;
  loading: boolean;
  errors: FeapiError[] | null;
}

const useHasLoyaltyProgram = (): LoyaltyProgramReturn => {
  const { data: userAccountData, errors, loading } = useUserAccount();
  const { data: isLoggedInUser } = useIsLoggedInUser();
  const isPrimeMarket = useIsPrimeMarket();

  const isLoyaltyProgramInSubscription: boolean =
    (userAccountData?.userAccount?.userMembership.subscriptionDetails
      ?.loyaltyRewardsProgram?.loyaltyRewards.length ?? 0) > 0;

  const isEligibleForLoyaltyProgram: boolean = Boolean(
    isMembershipActivatedWithUserAccountData(userAccountData) &&
      isPrimeMarket &&
      isLoggedInUser &&
      isLoyaltyProgramInSubscription,
  );

  return {
    userAccountData,
    isEligibleForLoyaltyProgram,
    loading,
    errors,
  };
};

export default useHasLoyaltyProgram;
